import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import { VForm } from "vuetify/lib";
import { VacationFlowDat } from "@/models/transaction/VacationFlowDat";
import { VacationApplicationRequest } from "@/models/petition/PetitionRequest";
import { PetitionShiftSearch } from "@/models/petition/PetitionResponse";
import { VacationDaysDatKey } from "@/models/transaction/VacationDaysDatKey";
import { DateTime } from "luxon";
import VacationForm, { FormType } from "@/components/form/VacationForm.vue";
import { $alert } from "@/plugins/alert/alert";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import SubstituteHolidayFrom, {
  Item
} from "@/components/form/SubstituteHolidayFrom.vue";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

type Props = {
  date: DateTime;
  shift?: PetitionShiftSearch;
  affiliationId: number;
  employeeId: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VacationApplication',
  props: {
    date: null,
    shift: null,
    affiliationId: null,
    employeeId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  date: DateTime;
  shift?: PetitionShiftSearch;
  affiliationId: number;
  employeeId: number;
};

const segmentItems = [
  { text: "休暇申請", value: "1" },
  { text: "振替申請", value: "0" }
] as const;

const segment = ref(0);



const form = ref<FormType>({});
const substitute = ref<Item>();

const vform = ref<VForm>();

const formatDate = (date?: string) => {
  if (date)
    return DateTime.fromSQL(date)
      .setLocale("ja")
      .toISO();
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", "入力に誤りがあります。\n入力内容を確認してください。");
    return;
  }
  const date = props.date.toISO();
  if (!date) {
    $alert("error", "申請に失敗しました。");
    return;
  }

  const days = new VacationDaysDatKey({
    recordId: 0,
    date: date
  });
  const dat = new VacationFlowDat({
    recordId: 0,
    employeeId: props.employeeId,
    affiliationId: props.affiliationId,
    shiftId: props.shift?.shiftId,
    requestDate: DateTime.local().toISO(),
    ...form.value,
    substituteShiftId: substitute.value?.value,
    substituteDate: formatDate(substitute.value?.text)
  });
  const request = new VacationApplicationRequest({
    vacationFlow: dat,
    vacationDays: [days]
  });
  const result = await $post(Paths.petition.insert.vacation, request);
  if (result) {
    $alert("success", "申請に成功しました。");
    return true;
  } else {
    $alert("error", "申請に失敗しました。");
    return false;
  }
};

watch(segment, () => {
  vform.value?.reset();
});

expose({
  onSubmit
});

return { __sfc: true,segmentItems, segment, props, form, substitute, vform, formatDate, onSubmit, VForm, VacationForm, SubstituteHolidayFrom }
}

})